import axios from 'axios'

export function getCareers() {
    return axios.get(`${process.env.REACT_APP_REPO}/v1/repo_aden/ecommerce/products`);
}